import { ILightRailItem, ISeriesTypeId } from '../../../types'
import {
  RailItemImage,
  RailItemName,
  RailItemProgramDetailsWrap,
  RailItemWrap,
} from './RailItemRegularProgram.style'
import { useRouter } from 'next/router'
import { useOttOverlay } from '../../../contexts/hooks/useOttOverlay'
import { IComponents } from '../../types'
import { ottRoot } from '../../Api'

export const RailItemRegularProgram = ({
  data,
  railType,
  showItemTitle,
  posterHeight,
}: {
  data: ILightRailItem
  railType: IComponents
  isLast: boolean
  isFirst: boolean
  showItemTitle?: boolean
  posterHeight?: number
}) => {
  const { setSeriesIdType } = useOttOverlay()
  const router = useRouter()

  const railTypeDimensions = (type: IComponents) => {
    if (posterHeight) {
      return { height: posterHeight }
    }
    switch (type) {
      case 'poster_small':
        return {
          height: 12.875,
        }
      default:
        return {
          height: 18,
        }
    }
  }
  const railTypeImageDimensions = () => {
    let height
    switch (railType) {
      case 'poster_small':
        height = 320
        break
      default:
        height = 420
        break
    }
    return `/width/${height}/height/${height * 1.5}/quality/70`
  }
  const displayTitle = () => {
    switch (railType) {
      case 'poster_small':
        return true
      default:
        return false
    }
  }

  const _click = () => {
    setSeriesIdType({ id: data.id, type: '' + data.type } as ISeriesTypeId)

    const programId =
      (data.metas?.SeriesID || '') &&
      data.typeDescription === 'Series' &&
      data.id

    if (programId) {
      const { SeriesID } = data.metas || {}
      if (SeriesID && SeriesID) {
        router.push(`${ottRoot}/series/${String(SeriesID)}`)
      }
    }
  }
  const railItemGetImageUrl = () => {
    const url = data.images.find(el => {
      return el.imageTypeName === 'Portrait_9_16'
    })?.url

    if (url) {
      return url + railTypeImageDimensions()
    }
    return 'https://media3.reshet.tv/image/upload/v1661761646/assets/2021/default_poster_image_tv.jpg'
  }
  const dimensions = railTypeDimensions(railType)
  const imagUrl = railItemGetImageUrl()
  return (
    <div onClick={_click} data-id={data.id}>
      <RailItemWrap>
        {data?.images[0]?.url && (
          <RailItemImage
            height={dimensions?.height}
            src={imagUrl}
            alt={data.name.trim()}
            title={data.name.trim()}
          />
        )}
      </RailItemWrap>
      <RailItemProgramDetailsWrap>
        {showItemTitle && (
          <RailItemName display={displayTitle() ? 'true' : undefined}>
            {data.name}
          </RailItemName>
        )}
      </RailItemProgramDetailsWrap>
    </div>
  )
}
